import axios, { AxiosError } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { ICompany } from '../interfaces';
import { sendError } from '@pec/aion-ui-core/sendError';
import { RootState } from '../combineReducers';
import {
  FETCH_ORGANIZATION_DETAILS_REQUEST,
  FETCH_ORGANIZATION_DETAILS_SUCCESS,
  FETCH_ORGANIZATION_DETAILS_FAILURE
} from '../constants/organizationDetails';

const fetchOrganizationDetailsRequest = () =>
  ({
    type: FETCH_ORGANIZATION_DETAILS_REQUEST
  } as const);

const fetchOrganizationDetailsSuccess = (payload: ICompany) =>
  ({
    type: FETCH_ORGANIZATION_DETAILS_SUCCESS,
    payload
  } as const);

const fetchOrganizationDetailsFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: FETCH_ORGANIZATION_DETAILS_FAILURE,
    error
  } as const;
};

export const fetchOrganizationDetails = (
  organizationId: string
): ThunkAction<void, RootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchOrganizationDetailsRequest());

    const { data } = await axios.get<ICompany>(`/api/v1/CompanyProfile/${organizationId}`);

    dispatch(fetchOrganizationDetailsSuccess(data));
  } catch (error) {
    dispatch(fetchOrganizationDetailsFailure(error));
  }
};

export type Actions =
  | ReturnType<typeof fetchOrganizationDetailsRequest>
  | ReturnType<typeof fetchOrganizationDetailsFailure>
  | ReturnType<typeof fetchOrganizationDetailsSuccess>;
